import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DashboardFacade } from '../store/dashboard.facade';

@Component({
  selector: 'app-mostactiveuserswidget',
  templateUrl: './mostactiveuserswidget.component.html',
  styleUrls: ['./mostactiveuserswidget.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class MostactiveuserswidgetComponent implements OnInit {
  
  public mostActiveUsers$ = this.dashboardFacade$.mostActiveUsers$;
  constructor(private dashboardFacade$: DashboardFacade) { }

  ngOnInit(): void {
    this.dashboardFacade$.fetchMostActiveUsers();
  }

}
